export default "__VITE_ASSET__DkfCJvWj__"